import { SHARED_REPORTS_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import {
  SharedReportLoginRequest,
  SharedReportRequest,
  SharedReportResponse,
} from "../types";

export const sharedReportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSharedReportIds: build.query<SharedReportResponse, SharedReportRequest>({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.token_key}/ids`,
        params: { fp: queryArg.fingerprint },
      }),
    }),
    sharedReportLogin: build.mutation<void, SharedReportLoginRequest>({
      query: (queryArg) => ({
        url: `${SHARED_REPORTS_ENDPOINT}/shared-reports/${queryArg.token_key}/login`,
        method: "POST",
        body: {
          password: queryArg.password,
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const { useGetSharedReportIdsQuery, useSharedReportLoginMutation } =
  sharedReportsApi;
